import api from "./api";


const inquireUserbyStatus=async(status) =>{
	
	const apiPath = `/account/inquireuserbystatus/${status}`;
	console.log("inquireuserbystatus " + apiPath);
	const response = api.get(apiPath);
	return response;
}

const inquireUserbyValidation=async(status) =>{
	
	const apiPath = `/account/inquireuserbyvalidation/${status}`;
	console.log("inquireuserbystatus " + apiPath);
	const response = api.get(apiPath);
	return response;
}

const inquiereUserVerification=async(usermail, reference) =>{
	
	const apiPath = `/account/inquireuserverification/${usermail}/${reference}`;
	console.log("inquiereUserVerification " + apiPath);
	const response = api.get(apiPath);
	return response;
}


const accountVerification=(apiParams) =>{
	
	const apiPath = `/account/accountverification`;  
	apiParams={ ...apiParams, tenantId: 1 };


	console.log("accountVerification " + apiPath);
	let url=apiPath;

	
	let data=apiParams;

	const response = api.post(url ,data);
	return response;
}

const updateUsers = (apiParams) => {

	const apiPath = `/account/updateusers`;

	console.log("updateuser " + apiPath);
	let url = apiPath;
	let data = apiParams;

	const response = api.post(url, data);
	return response;
}



const updateApproval = (apiParams) => {

	const apiPath = `/approval/update`;

	console.log("update " + apiPath);
	let url = apiPath;
	let data = apiParams;

	const response = api.post(url, data);
	return response;
}

const inquireUserWithToken = async (token) => {

	const apiPath = `/account/user`;
	console.log("inquiereUser");
	api.defaults.headers = {'Authorization': `Bearer ${token}`}

	const response = await api
		.get(apiPath);
	return response;
};


const inquireUser = async () => {

	const apiPath = `/account/user`;
	console.log("inquiereUser");
	
	const response = await api
		.get(apiPath);
	return response;
};


const uploadProfileImage = async (apiParams) => {

	const apiPath = `/authentication/uploadprofile`;

	console.log("uploadProfileImage " + apiPath);
	let url = apiPath;
	let data = apiParams;

	const response = api.post(url, data);
	return response;
};

const waitlist=async(email) =>{
	
	const apiPath = `/waitlist/waitlist?email=${email}`;
	console.log("waitlist " + apiPath);
	const response = await api
	.post(apiPath);
return response;
}
const inquirewaitlistbystatus=async(status) =>{
	
	const apiPath = `/waitlist/inquirewaitlistbystatus/${status}`;
	console.log("inquirewaitlistbystatus " + apiPath);
	const response = api.get(apiPath);
	return response;
}
const inquireRoles=async() =>{
	
	const apiPath = `/account/inquireroles`;
	console.log("inquireroles " + apiPath);
	const response = api.get(apiPath);
	return response;
}


const updateWaitList = (apiParams) => {

	const apiPath = `/waitlist/update`;

	console.log("update " + apiPath);
	let url = apiPath;
	let data = apiParams;

	const response = api.post(url, data);
	return response;
}

const AccountService = {
	inquireUserbyStatus,
	inquireUserbyValidation,
	inquiereUserVerification,
	accountVerification,

	updateUsers,
	updateApproval,
	inquireUser,
	inquireUserWithToken,
	uploadProfileImage,

	inquireRoles,
	
	waitlist,
	inquirewaitlistbystatus,
	updateWaitList,
	
};

export default AccountService;
